import * as Sentry from '@sentry/react';

// ブランドごとのDSN
const sentryDsns = {
  runport: 'https://29a683a852975c108ab25fa8f381022a@o496919.ingest.us.sentry.io/4510746916159488',
  skiday: 'https://e0c2b6146c20550dc8fb592f15564efe@o496919.ingest.us.sentry.io/4510746918322176',
};

// hostnameからブランドを判定
function getBrand() {
  const hostname = window.location.hostname;

  if (hostname.includes('skiday')) {
    return 'skiday';
  }

  return 'runport';
}

// hostnameベースの環境判定
function getEnvironment() {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'dev';
  }

  if (hostname.startsWith('dev-') || hostname.includes('-dev')) {
    return 'dev';
  }

  if (hostname.startsWith('demo-') || hostname.includes('-demo')) {
    return 'demo';
  }

  return 'prod';
}

const brand = getBrand();
const environment = getEnvironment();
const isDevelopment = environment === 'dev';
const isProduction = environment === 'prod';
const isDemo = environment === 'demo';

export function initSentry() {
  // demo環境は無効
  if (isDemo) {
    console.info('Sentry is disabled for demo environment');
    return;
  }

  // 本番環境は常にON、開発環境はlocalStorageで制御
  const sentryEnabled = isProduction || localStorage.getItem('sentryEnabled') === 'true';

  if (!sentryEnabled) {
    console.info('Sentry is disabled for development environment');
    return;
  }

  const dsn = sentryDsns[brand];

  if (!dsn || dsn.startsWith('YOUR_')) {
    console.warn('Sentry DSN not configured for brand:', brand);
    return;
  }

  Sentry.init({
    dsn,
    environment,

    // エラー監視のみ（パフォーマンス監視は無効）
    tracesSampleRate: 0,

    // リリース情報（ビルド時に生成されたID）
    release: `ver.${__BUILD_ID__}`,

    // エラーの前処理
    beforeSend(event) {
      // 開発環境ではコンソールにも出力
      if (isDevelopment) {
        console.error('Sentry error:', event);
      }
      return event;
    },

    // プライバシー設定
    sendDefaultPii: false,

    // 自動的にセッション追跡
    autoSessionTracking: true,

    // 除外するエラー
    ignoreErrors: [
      // ネットワークエラーなど、アプリケーションのバグではないもの
      'Network Error',
      'NetworkError',
      'Failed to fetch',

      // ブラウザの拡張機能によるエラー
      'Non-Error promise rejection captured',
      'ResizeObserver loop limit exceeded',

      // PWA関連のエラー
      'ServiceWorker script evaluation failed',
      'Failed to register a ServiceWorker',

      // モバイルブラウザでよくあるエラー
      'Script error.',

      // 開発環境でよくあるエラー
      'ChunkLoadError',

      // Firebase Performance の MUI 関連エラー
      'Performance: Attribute value',
      'performance/invalid attribute value',
    ],
  });

  console.info(`Sentry initialized for ${brand}-desk (${environment})`);

  // dev環境ではコンソールからテストできるようにwindowに公開
  if (isDevelopment) {
    window.Sentry = Sentry;
  }
}

export { Sentry };
